import "./Faq.css";
import React from "react";

function Faq() {
  const faqs = [
    {
      q: "At what age should my child first see a paediatrician?",
      a: "It is recommended to bring your newborn to see a paediatrician within the first few days, for newborn care and vaccinations.",
      open: true
    },
    {
      q: "How often should my child visit the paediatrician?",
      a: "Children should have regular visits during their first year of life, and then annually for routine health check-ups."
    },
    {
      q: "What vaccinations does my child need?",
      a: "Your child will need infant vaccines, childhood immunisations and booster shots as per the vaccination schedule."
    },
    {
      q: "Can Dr. Mahesh Rao help with childhood asthma?",
      a: "Yes. Dr. Mahesh Rao specialises in the diagnosis and management of asthma and allergies in children."
    },
    {
      q: "Does the centre treat childhood illnesses?",
      a: "Yes. We treat a wide range of childhood illnesses including fever, cold, ear infections and more."
    },
    {
      q: "How do I book an appointment?",
      a: "Call the centre on 080 2334 7276, email lakshmimaternityhome@gmail.com, or use the appointment form on this page and we will call you back to confirm a time."
    }
  ];

  return (
    <section className="band" id="faq">
      <div className="wrap">
        <p className="eyebrow">Questions parents ask</p>
        <h2 className="h-sec">Before your first visit.</h2>
        <div className="faq">
          {faqs.map((item, index) => (
            <details key={index} defaultOpen={item.open}>
              <summary>{item.q}</summary>
              <p>{item.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Faq;

